export default [
  {
    icon: "UsersIcon",
    menu: "Mahasiswa",
    url: "kemahasiswaan-mahasiswa",
  },
];
